import React, { forwardRef } from 'react';
import { Box, createStyles, withStyles, Theme, BoxProps } from '@material-ui/core';
import createNameSpacedComponent from 'global/react/utils/ts/createNamespacedComponent';

const GridContainer = withStyles((theme: Theme) => createStyles({}))((props: BoxProps) => <Box className={'o-service-order-booking-form-grid-container'} {...props} />);
const SidebarArea = (props: BoxProps) => <Box className={'o-service-order-booking-form-sidebar'} {...props} />;
const Content = forwardRef((props: BoxProps & { ref: React.MutableRefObject<HTMLElement | undefined> }, ref) => <Box className={'o-service-order-booking-form-content'} {...props} />);
export default createNameSpacedComponent(GridContainer, { SidebarArea, Content });
